import styled from "styled-components";

export default function CustomButton({ onClick, title, isActive = false, src, alt }) {
  return (
    <CustomButtonContainer onClick={onClick} isActive={isActive}>
      <img src={src} alt={alt} />
      <span>{title}</span>
    </CustomButtonContainer>
  );
}

const CustomButtonContainer = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 24px;
  padding: 0 10px;
  background-color: ${({ isActive }) => (isActive ? "#0f77ffff" : "white")};
  color: ${({ isActive }) => (isActive ? "white" : "black")};
  font-weight: ${({ isActive }) => (isActive ? "bold" : "normal")};
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;

  img {
    height: 16px;
  }

  &:hover {
    background-color: ${({ isActive }) => (isActive ? "#0f77ffff" : "#ececec")};
  }
`;
